import React, { Component } from "react";

import RequireUnauth from "../../layout/HOC/require-unauth";

import "./LicenseInfo.scss";

class LicenseInfo extends Component {
  render() {
    return (
      <div className="ext-page-wrap license">
        <div className="license-content">
          <h1>Используемые библиотеки:</h1>
          <h2>Лицензия MIT</h2>
          <div className="license-items">
            axios, connected-react-router, immutability-helper, jsonwebtoken, lodash, moment, node-sass, react, react-dom,
            react-lines-ellipsis, React Redux, react-router, react-router-dom, react-scripts, redux, Redux DevTools Extension's helper,
            redux-thunk, semantic-ui-css, semantic-ui-react.
          </div>
          <h2>Лицензия BSD-3-Clause</h2>
          <div className="license-items">
            react-transition-group, qs.
          </div>
        </div>
      </div>
    );
  }
}

export default RequireUnauth(LicenseInfo);
